import { useState, useEffect, RefObject } from "react";

const useScrollDetection = (ref?: RefObject<HTMLElement>, threshold = 0) => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (ref && ref.current) {
        const { scrollTop } = ref.current;
        setIsScrolled(scrollTop > threshold);
      } else {
        const scrollPosition = window.scrollY;
        setIsScrolled(scrollPosition > threshold);
      }
    };

    const currentRef = ref?.current;
    if (currentRef) {
      currentRef.addEventListener("scroll", handleScroll);
    } else {
      window.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (currentRef) {
        currentRef.removeEventListener("scroll", handleScroll);
      } else {
        window.removeEventListener("scroll", handleScroll);
      }
    };
  }, [ref, threshold]);

  return isScrolled;
};

export default useScrollDetection;
